import React, { useState, useEffect } from 'react';
import '../styles.css';
import { connect, useDispatch } from 'react-redux';
import BackButton from '../COMPONENTS/BackButton';
import { NoGradientBackground } from '../COMPONENTS/Background';
import HomeButton from '../../HOME/COMPONENTS/HomeButton';
import ContactButton from '../../HOME/COMPONENTS/ContactButton';
import { START_PAGE, YOUTUBE } from '../../HOME/const';
import { goToPage, forceUpdate, GOTO_GAME_PAGE } from '../../HOME/REDUX/actions';
import { HELPED_KEY, RE_RED, YOUTUBE_RE } from '../const';
import Board from '../COMPONENTS/Board';
import { useSpring, animated } from 'react-spring';
import { pause } from '../REDUX/actions';
import PlayIcon from '../../HOME/SVG/PlayIcon';
import { scrollClass, dbget, dbset } from '../../HOME/utils';

const HelpPage = props => {
  const dispatch = useDispatch();
  const [play, setPlay] = useState(false);
  const [good, setGood] = useState(false);
  const [excellent, setExcellent] = useState(false);
  const { fromPage, size, forceUpdate, pause } = props;

  useEffect(() => {
    window.addEventListener('resize', forceUpdate);

    pause();

    if (fromPage === START_PAGE && size) {
      dbget(HELPED_KEY, response => setPlay(!response));
    }

    return () => {
      window.removeEventListener('resize', forceUpdate);
      dbset(HELPED_KEY, true);
      dispatch({ type: HELPED_KEY });
    };
  }, [fromPage, size, forceUpdate, pause, dispatch]);

  const goodFadeOut = useSpring({ opacity: good ? 0 : 1 });
  const goodFadeIn = useSpring({ opacity: good ? 1 : 0 });
  const excellentFadeOut = useSpring({ opacity: excellent ? 0 : 1 });
  const excellentFadeIn = useSpring({ opacity: excellent ? 1 : 0 });

  const styleBold = { color: RE_RED, fontWeight: 'bold' };

  return (
    <div className="page-root">
      <div className="re-page re-help-page" style={{ backgroundImage: NoGradientBackground }}>
        <div className={scrollClass} style={{ margin: '25px 20px 55px' }}>
          <div className="re-help-column">
            <div style={{ overflow: 'auto' }}>
              The object of the game is to <span style={styleBold}>stack</span> the required number of cards so that every disk fits into a
              circle of the same color, and to do it as fast as possible.
            </div>
            <div style={{ overflow: 'auto', marginTop: '10px', display: 'grid' }}>
              <animated.span style={{ gridArea: '1/1', opacity: goodFadeOut.opacity, alignSelf: 'center' }}>
                Select <span style={styleBold}>two cards</span> to make a two-card stack:
              </animated.span>
              <animated.span style={{ gridArea: '1/1', opacity: goodFadeIn.opacity, alignSelf: 'center' }}>
                Good! <span style={styleBold}>Tap any card to try again.</span>
              </animated.span>
            </div>
            <div className="re-help-board">
              <Board rows={1} cols={4} stackSize={2} callback={over => setGood(over)} />
            </div>
          </div>
          <div className="re-help-column" style={{ marginTop: '10px' }}>
            <div style={{ overflow: 'auto', display: 'grid' }}>
              <animated.span style={{ gridArea: '1/1', opacity: excellentFadeOut.opacity, alignSelf: 'center' }}>
                Select <span style={styleBold}>three cards</span> to make a three-card stack:
              </animated.span>
              <animated.span style={{ gridArea: '1/1', opacity: excellentFadeIn.opacity, alignSelf: 'center' }}>
                Exellent! <span style={styleBold}>Tap any card to try again.</span>
              </animated.span>
            </div>
            <div className="re-help-board">
              <Board rows={1} cols={4} stackSize={3} callback={over => setExcellent(over)} />
            </div>
            <div style={{ overflow: 'auto', marginTop: '10px' }}>
              Your <span style={styleBold}>grade</span> is based on your average score and the number of times the game has been played. Play{' '}
              <span style={styleBold}>ten times</span> or more to get full credit. Good luck!
            </div>
          </div>
        </div>
      </div>
      {play && (
        <span className="navigation-button" style={{ left: 'initial', right: '10px' }} onClick={() => dispatch(GOTO_GAME_PAGE)}>
          <PlayIcon width="36" color="black" />
        </span>
      )}
      <div className="home-center-button-toolbar">
        <ContactButton size={36} service={YOUTUBE} url={YOUTUBE_RE} style={{ color: '#000000C6' }} />
      </div>
      <BackButton />
      <HomeButton color="black" />
    </div>
  );
};

function mapStateToProps({ re, common }) {
  return { ...re, ...common };
}

export default connect(
  mapStateToProps,
  { goToPage, forceUpdate, pause }
)(HelpPage);
